	import { HttpHeaders } from '@angular/common/http';
	import { Injectable } from '@angular/core';
	import { RestApiService } from '../../../../src/app/rest-api.service';

	@Injectable({
	providedIn: 'root'
	})
	export class CommonService {

	constructor(public api: RestApiService) { }

	/** get Collection Dispatch Transfer Wise To WMA List  **/
	getParameterSettings(id) {
		return this.api.post("/common/parametersSettings", { 'id': id });
	}

	getSubjectArea(id) {
		return this.api.post("/common/getSubjectArea", { 'id': id });
	}

	/** get Country List  **/
	getCountryData() {
		// const headers = new HttpHeaders()
		// .set("Authorization", "Bearer " + localStorage.getItem("token"))
		return this.api.post("/common/getCountryDetails", {});
	}

	/** get State List  **/
	getStateData(countryId) {
		// const headers = new HttpHeaders()
		// .set("Authorization", "Bearer " + localStorage.getItem("token"))
		return this.api.post("/common/getStateDetails", { 'countryId': countryId });
	}

	/** get State List  **/
	getAllStateData() {
		// const headers = new HttpHeaders()
		// .set("Authorization", "Bearer " + localStorage.getItem("token"))
		return this.api.post("/common/getAllStateDetails", {});
	}

	/** get District List  **/
	getDistrictData(stateId: number) {
		// const headers = new HttpHeaders()
		// .set("Authorization", "Bearer " + localStorage.getItem("token"))
		return this.api.post("/common/getDistrictDetails", { stateId });
	}

	/** get City List  **/
	getCityData(stateId: number) {
		// const headers = new HttpHeaders()
		// .set("Authorization", "Bearer " + localStorage.getItem("token"))
		return this.api.post("/common/getCityDetails", { stateId });
	}

	/** get co-investigator List  **/
	getCoPrincipalInvestigatorData(customerName: string) {
		const headers = new HttpHeaders().set("Authorization", "Bearer " + localStorage.getItem("token"))
		return this.api.post("/common/getRegisterCustomer", { customerName, headers });
	}

	/** get expert user List  **/
	getExpertListData(expertCategoryId: any) {
		const headers = new HttpHeaders().set("Authorization", "Bearer " + localStorage.getItem("token"))
		return this.api.post("/common/getExpertList", { 'expertCategoryId': expertCategoryId, headers });
	}

	/** get Expert Comment Rating List */
	getExpertCommentRatingList() {
		const headers = new HttpHeaders().set("Authorization", "Bearer " + localStorage.getItem("token"))
		return this.api.post("/getExpertCommentRatingList", { headers });
	}
	/** get department from subject area */
	getDepartmentFromSubject(subjectIds:any){
		return this.api.post("/common/getDepartments", { 'subjectAreaIds': subjectIds });
	}
	getCategoryFromDepartment(departmentIds:any){
		return this.api.post("/common/getCategoryFromDepartment", { 'departmentIds': departmentIds });
	}
}
